var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useSlotRecipe } from "@chakra-ui/react";
import { useState } from "react";
import { ViewJobStickyHeaderWrapper } from "./ViewJobStickyHeaderWrapper";
export function ViewJob(_a) {
    var jobTitle = _a.jobTitle, takeFocus = _a.takeFocus, header = _a.header, body = _a.body, footer = _a.footer, rest = __rest(_a, ["jobTitle", "takeFocus", "header", "body", "footer"]);
    var recipe = useSlotRecipe({ key: "ViewJob" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var _b = useState(false), isBodyScrolled = _b[0], setIsBodyScrolled = _b[1];
    return (_jsxs(Box, __assign({ css: styles.container, as: "aside", outline: "none", "aria-label": jobTitle }, rest, { children: [header && (_jsx(ViewJobStickyHeaderWrapper, __assign({ takeFocus: takeFocus, isStuck: isBodyScrolled }, { children: header }))), _jsx(Box, __assign({ tabIndex: 0, css: styles.body, onScroll: function (e) {
                    setIsBodyScrolled(e.currentTarget.scrollTop > 0);
                } }, { children: body })), footer] })));
}
